import axios from "./axios";

const jsonHeaders = { "Content-Type": "application/json;charset=UTF-8" };

const postJson = (url, data) => axios.post(url, data || {}, { headers: jsonHeaders });

export default {
  // Users -------------------------------------------------------------
  listUsers() {
    return axios.get("/system/user/list");
  },
  saveUser(user) {
    return postJson("/system/user/save", user);
  },
  deleteUser(id) {
    return postJson(`/system/user/delete/${id}`);
  },
  getUserRoles(id) {
    return axios.get(`/system/user/${id}/roles`);
  },
  assignUserRoles(id, roleIds) {
    return postJson(`/system/user/${id}/roles`, { roleIds });
  },

  // Roles -------------------------------------------------------------
  listRoles() {
    return axios.get("/system/role/list");
  },
  saveRole(role) {
    return postJson("/system/role/save", role);
  },
  deleteRole(id) {
    return postJson(`/system/role/delete/${id}`);
  },
  getRoleMenus(id) {
    return axios.get(`/system/role/${id}/menus`);
  },
  assignRoleMenus(id, menuIds) {
    return postJson(`/system/role/${id}/menus`, { menuIds });
  },

  // Menus -------------------------------------------------------------
  listMenus() {
    return axios.get("/system/menu/list");
  },
  saveMenu(menu) {
    return postJson("/system/menu/save", menu);
  },
  deleteMenu(id) {
    return postJson(`/system/menu/delete/${id}`);
  },

  // Api resources -----------------------------------------------------
  listApiResources() {
    return axios.get("/system/api-resource/list");
  },
  saveApiResource(res) {
    return postJson("/system/api-resource/save", res);
  },
  deleteApiResource(id) {
    return postJson(`/system/api-resource/delete/${id}`);
  },
};
